export const pointsMixin = {
  data() {
    return {
      pointsForJournalSteps: "entries",
      pointsForJournalPhoto: "photos",
      pointsForJournalText: "blog",
      pointsForWellnessMood: "mood",
      pointsForWellnessNutrition: "nutrition",
      pointsForWellnessSleep: "sleep",
      pointsForWellnessWater: "water",
      pointsForWellnessWeight: "weight",
      pointsForWellnessHeart: "heart",
      pointsForWellnessMindfulness: "mindfulness",
      pointsForQuestion: "question"
    };
  }
};
